export default __webpack_public_path__ + "static/media/step3landing.52492310.jpg";